import React, {Fragment, useContext, useEffect, useState} from 'react';
import SelectionUnitInput from "../../reusable/ControlledForm/Inputs/SelectionUnitInput";
import {massUnits} from "../../global/lists";
import RoundButton from "../../reusable/Actions/RoundButton";
import { Svgs } from '../../assets/svgs/Svgs';
import {useCSSVariables} from "../../hooks/useCSSVariables";
import Center from "../../reusable/Layouts/Center";
import {IngredientDataHandler} from "../../logic/db/IngredientDataHandler";
import {ControlledFormContext} from "../../reusable/ControlledForm/ControlledForm";
import {defaultRecipeIngredient} from "../../global/defaults";
import Divider from "../../reusable/Styles/Divider";
import {Utils} from "../../logic/reusable/Utils";
import {RecipeModel} from "../../logic/models/RecipeModel";
import {useTranslation} from "react-i18next";

function RecipeFormIngredients() {
    const {formData, setFormData} = useContext(ControlledFormContext)
    const [allIngredients, setAllIngredients] = useState<Ingredient[]>([])
    const cssVars = useCSSVariables()
    const {t} = useTranslation("common")
    const {t: tBaking} = useTranslation("baking")
    const massOptions = massUnits.map(unit => { return {value: unit, name: t((`units.mass.${unit}`))}})


    useEffect(() => {
        IngredientDataHandler.getIngredients().then(result => {
            setAllIngredients(result as Ingredient[]);
        }).catch(reason => {
            console.log(reason)
        })
        IngredientDataHandler.registerIngredientListener(setAllIngredients)
    }, [])

    const onDelete = (ingredientIndex: number) => {
        setFormData(prevState => {
            const old = JSON.parse(JSON.stringify(prevState))
            Utils.dynamicKeyDelete(old, `ingredient-name-${ingredientIndex}`)
            Utils.dynamicKeyDelete(old, `ingredient-mass-${ingredientIndex}`)
            Utils.dynamicKeyDelete(old, `ingredient-unit-${ingredientIndex}`)
            return new RecipeModel({formData: old}).toFormData()
        })
    }

    const onAdd = (event: any) => {
        event.preventDefault()
        const length =  new RecipeModel({formData: formData}).recipe.ingredients.length
        setFormData(prevState => {
            const old = JSON.parse(JSON.stringify(prevState))
            old[`ingredient-name-${length}`] = allIngredients[0].name
            old[`ingredient-mass-${length}`] = defaultRecipeIngredient.mass.value
            old[`ingredient-unit-${length}`] = defaultRecipeIngredient.mass.unit
            return new RecipeModel({formData: old}).toFormData()
        })
    }

    const ingredientOptions = allIngredients.map(ingredient => {
        return {name: ingredient.name, value: ingredient.name}
    })

    return ( allIngredients.length > 0 ?
        <Fragment>
            {
                new RecipeModel({formData}).recipe.ingredients.map((ingredient, index) => {
                    return (
                        <Fragment>
                            <Divider/>
                            <SelectionUnitInput key={index} selectionName={`ingredient-name-${index}`} numberName={`ingredient-mass-${index}`} unitName={`ingredient-unit-${index}`}
                                                selectionOptions={ingredientOptions} unitOptions={massOptions} label={tBaking('ingredient_one') + ' ' + (index + 1)} actions={
                                <RoundButton onMouseUp={() => onDelete(index)} iconSvg={<Svgs.MinusSvg color={cssVars.NegativeColor}/>}/>
                            }/>
                        </Fragment>
                    )
                })
            }
            <Divider/>
            <Center>
                <RoundButton onMouseUp={(event) => onAdd(event)} iconSvg={<Svgs.PlusSvg color={cssVars.PositiveColor}/>}/>
            </Center>
        </Fragment> : null
    )
}

export default RecipeFormIngredients;
